/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const REQUESTED_NASU_APPLICATIONS = 'REQUESTED_NASU_APPLICATIONS';
export const requestedNASUApplications = () => {
  return {
    type: REQUESTED_NASU_APPLICATIONS
  };
};

export const RECEIVED_NASU_APPLICATIONS = 'RECEIVED_NASU_APPLICATIONS';
export const receivedNASUApplications = (applications) => ({
  type: RECEIVED_NASU_APPLICATIONS,
  applications
});

export const ERROR_NASU_APPLICATIONS = 'ERROR_NASU_APPLICATIONS';
export const errorNASUApplications = (error) => ({
  type: ERROR_NASU_APPLICATIONS,
  error
});

export const REQUESTED_DELETE_IN_PROGRESS_APPLICATION =
  'REQUESTED_DELETE_IN_PROGRESS_APPLICATION';
export const requestedNASUDeleteApplications = () => {
  return {
    type: REQUESTED_DELETE_IN_PROGRESS_APPLICATION
  };
};

export const RECEIVED_DELETE_IN_PROGRESS_APPLICATION =
  'RECEIVED_DELETE_IN_PROGRESS_APPLICATION';
export const receivedNASUDeleteApplications = (applicationID) => ({
  type: RECEIVED_DELETE_IN_PROGRESS_APPLICATION,
  applicationID
});

export const ERROR_DELETE_IN_PROGRESS_APPLICATION =
  'ERROR_DELETE_IN_PROGRESS_APPLICATION';
export const errorNASUDeleteApplications = (error) => ({
  type: ERROR_DELETE_IN_PROGRESS_APPLICATION,
  error
});
